// frontend/shared-ui/src/components/ViewToggle.jsx
import React from "react";

const ListIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="8" y1="6" x2="21" y2="6" />
    <line x1="8" y1="12" x2="21" y2="12" />
    <line x1="8" y1="18" x2="21" y2="18" />
    <line x1="3" y1="6" x2="3.01" y2="6" />
    <line x1="3" y1="12" x2="3.01" y2="12" />
    <line x1="3" y1="18" x2="3.01" y2="18" />
  </svg>
);

const GridIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="3" width="7" height="7" />
    <rect x="14" y="3" width="7" height="7" />
    <rect x="14" y="14" width="7" height="7" />
    <rect x="3" y="14" width="7" height="7" />
  </svg>
);

const DEFAULT_OPTIONS = [
  { value: "list", icon: <ListIcon />, label: "List" },
  { value: "grid", icon: <GridIcon />, label: "Grid" },
];

/**
 * <ViewToggle
 *   value="grid"
 *   onChange={(v) => setView(v)}
 *   options={[...]}    // optional custom
 *   size="sm"          // 'sm' | 'md'
 * />
 */
export default function ViewToggle({
  value,
  onChange,
  options = DEFAULT_OPTIONS,
  size = "md",
  className = "",
}) {
  return (
    <div
      className={`fh-view-toggle fh-view-toggle--${size} ${className}`}
      role="group"
      aria-label="View mode"
    >
      {options.map((opt) => {
        const active = value === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            className={`fh-view-toggle__btn ${active ? "is-active" : ""}`}
            onClick={() => onChange?.(opt.value)}
            aria-pressed={active}
            title={opt.label}
          >
            {opt.icon}
            {opt.label && (
              <span className="fh-view-toggle__label">{opt.label}</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
